module.exports = __webpack_public_path__ + "img/hoang.41632362.jpg";